import {css, useTheme} from '@mui/material';
import {DlMuiComponentBox, GetStylesFunction, IconHeaderWithSearch, NoDataMessageWithIcon} from '@wallaby-ui/core';
import * as React from 'react';
import {DocumentColors} from 'src/js/common';

import {DlMuiTag} from './DlMuiTag';

type TagOption = {
  id: string;
  label: string;
  selected: boolean;
};
type Props = {
  tags: TagOption[];
  onClickTag: (id: string) => void;
  getDocumentColors: (id: string) => DocumentColors;
  showBoxHeader?: boolean;
  titleText?: string;
};

export const DlMuiDocumentConcepts: React.FC<Props> = (props) => {
  const {tags, onClickTag, getDocumentColors, showBoxHeader = false, titleText = 'document.concepts.title'} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div css={styles.wrapper}>
      {showBoxHeader ? <IconHeaderWithSearch label={titleText} /> : null}
      <DlMuiComponentBox isOverflow={false}>
        {tags.length > 0 ? (
          <div style={{width: '100%', height: '100%', color: 'var(--dlFont)'}}>
            {tags.map((tag) => {
              return (
                <DlMuiTag
                  key={tag.id}
                  id={tag.id}
                  label={tag.label}
                  selected={tag.selected}
                  onClick={onClickTag}
                  colors={getDocumentColors(tag.id)}
                />
              );
            })}
          </div>
        ) : (
          <NoDataMessageWithIcon message={'document.concepts.noData'} />
        )}
      </DlMuiComponentBox>
    </div>
  );
};

DlMuiDocumentConcepts.displayName = 'DlMuiDocumentConcepts';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css`
    background-color: ${options?.theme?.palette.custom.coolGray['50']};
    gap: ${options?.theme?.spacing(3)};
    display: flex;
    flex-direction: column;
    padding: ${options?.theme?.spacing(4)};
    align-items: flex-start;
    align-self: stretch;
    border-radius: ${options?.theme?.spacing(6)};
    overflow: hidden;
  `,
});
